export const langList = [
  { id: 0, name: "IDIOMA DE LA PAGINA" },
  { id: 1, name: "ESPAÑOL - ES" },
  { id: 2, name: "INGLES - EN" },
];
